import { render, staticRenderFns } from "./featured_matches.vue?vue&type=template&id=6ec7fee9&"
import script from "./featured_matches.vue?vue&type=script&lang=js&"
export * from "./featured_matches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports